'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var hooks_useRandomId = require('../use-random-id/index.js');

/**
 * Generates a random id with the input prefix unless an
 *   id is provided.
 *
 * Due to the nature of hooks, a randomized id will always
 *   be generated even if not used.
 *
 * @param givenId - id to use (if provided)
 * @param randomPrefix - prefix to use for randomized id
 *   (if id not provided)
 * @returns givenId or a random id
 */
var useElementId = function useElementId(givenId, randomPrefix) {
  var randomizedId = hooks_useRandomId.useRandomId(randomPrefix);
  return React.useMemo(function () {
    return givenId || randomizedId;
  }, [givenId, randomizedId]);
};

exports.useElementId = useElementId;
//# sourceMappingURL=index.js.map
